import { makeAutoObservable } from "mobx";
import { openApi } from "../../helpers/request";
import { FormEvent } from "react";
import { notification } from "antd";

class FunctionComponentController {

    lists: any = {}
    items: any = {}
    models: any = {}
    formAction: any = {}

    constructor() {
        makeAutoObservable(this)
    }

    randKey() {
        const characters = 'abcdefghijklmnopqrstuvwxyz0123456789';
        return Array.from({ length: 5 }, () => characters.charAt(Math.floor(Math.random() * characters.length))).join('');
    }

    request(options: any, key: string, result_action: any = null) {
        if (!key) return

        const method = options.method || 'get'
        const path = options.path || ''
        const data = options.data || {}

        openApi(method, path, data)
            .then(result => {
                const resultData = options.prepareData ? options.prepareData(result.data) : result.data

                if (options.entity === 'lists') {
                    this.lists[key] = resultData
                } else if (options.entity === 'model') {
                    this.models[key] = {
                        ...(this.models[key] ?? {}),
                        ...resultData
                    }
                }

                if (result_action && result_action.redirect) {
                    window.location.href = result_action.redirect
                }
            })
            .catch(err => {
                console.log(err.response)
            })
    }

    appendFormValue(data: FormData, name: string, value: any) {
        if (name.indexOf('_') === 0) return

        if (value === null || value === undefined) return

        if (name === 'image_uri' && String(value).trim() === '') {
            return
        }

        if (typeof value === 'boolean') {
            data.append(name, value ? '1' : '0')
            return
        }

        if (value instanceof File) {
            data.append(name, value)
            return
        }

        if (Array.isArray(value)) {
            value.forEach((item, index) => {
                if (item === null || item === undefined) return

                if (typeof item === 'object') {
                    if (item.id !== undefined && item.id !== null) {
                        data.append(`${name}[${index}]`, String(item.id))
                    }
                    return
                }

                data.append(`${name}[${index}]`, String(item))
            })
            return
        }

        if (typeof value === 'object') {
            return
        }

        data.append(name, String(value))
    }

    sendForm(e: FormEvent, key: string) {
        e.preventDefault()

        const data = new FormData()

        Object.keys(this.models[key]).forEach((el: any) => {
            this.appendFormValue(data, el, this.models[key][el])
        })

        let path = this.formAction.path

        if (this.formAction.isId && this.models[key].id && this.models[key].id > 0) {
            path += `/${this.models[key].id}`
        }

        openApi(this.formAction.method, path, data)
            .then(result => {
                console.log(result)

                const resultAction = this.formAction.result ?? {}

                if (resultAction.notification) {
                    notification.success(resultAction.notification)
                    return
                }

                if (resultAction.redirect) {
                    window.location.href = resultAction.redirect
                }
            })
            .catch(err => {
                console.log(err.response)
            })
    }

    delete(id: number, data: any = null) {
        if (data) {
            if (data.formAction) {
                this.request({
                    method: data.formAction.method,
                    path: data.formAction.path + `/${id}`,
                }, 'asd', data.formAction.result ?? null)
            }
        }
    }

}

export default new FunctionComponentController()